/**
 * ModuleMD PatientPortal API
 * ModuleMD PatientPortal API service
 *
 * OpenAPI spec version: 1.0.0
 * Contact: emrsupport@modulemd.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import {
    HttpClient, HttpHeaders, HttpParams,
    HttpResponse, HttpEvent
} from '@angular/common/http';
import { CustomHttpUrlEncodingCodec } from '../encoder';

import { Observable } from 'rxjs/Observable';

import { PatientPortalMessageBoard, PatientPortalMessage } from '../model/patientPortalMessageBoard';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { environment } from '../../environments/environment';

@Injectable()
export class PatientPortalMessageBoardService {

    protected basePath = environment.appSetting.apiUrl + 'patientportal';
    protected baseComPath = environment.appSetting.apiUrl + 'communication';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Referenced to SOA.PatientPortalMessageBoard
     * This API get PatientPortalMessageBoard
     * @param roleId RoleId
     * @param practiceCode practice Code
     * @param messageType MessageType
     * @param patientID PatientID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patientPortalMessageBoard(roleId: string, practiceCode: string, messageType: string, patientID: number, observe?: 'body', reportProgress?: boolean): Observable<Array<PatientPortalMessageBoard>>;
    public patientPortalMessageBoard(roleId: string, practiceCode: string, messageType: string, patientID: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<PatientPortalMessageBoard>>>;
    public patientPortalMessageBoard(roleId: string, practiceCode: string, messageType: string, patientID: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<PatientPortalMessageBoard>>>;
    public patientPortalMessageBoard(roleId: string, practiceCode: string, messageType: string, patientID: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (roleId === null || roleId === undefined) {
            throw new Error('Required parameter roleId was null or undefined when calling patientPortalMessageBoard.');
        }

        if (practiceCode === null || practiceCode === undefined) {
            throw new Error('Required parameter practiceCode was null or undefined when calling patientPortalMessageBoard.');
        }

        if (messageType === null || messageType === undefined) {
            throw new Error('Required parameter messageType was null or undefined when calling patientPortalMessageBoard.');
        }

        if (patientID === null || patientID === undefined) {
            throw new Error('Required parameter patientID was null or undefined when calling patientPortalMessageBoard.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        if (roleId !== undefined && roleId !== null) {
            queryParameters = queryParameters.set('RoleId', <any>roleId);
        }
        if (practiceCode !== undefined && practiceCode !== null) {
            queryParameters = queryParameters.set('practiceCode', <any>practiceCode);
        }
        if (messageType !== undefined && messageType !== null) {
            queryParameters = queryParameters.set('MessageType', <any>messageType);
        }
        if (patientID !== undefined && patientID !== null) {
            queryParameters = queryParameters.set('PatientID', <any>patientID);
        }

        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<PatientPortalMessageBoard>>(`${this.basePath}/PatientPortalMessageBoard`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    public patientPortalMessages(messageType: string, patientID: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (messageType === null || messageType === undefined) {
            throw new Error('Required parameter messageType was null or undefined when calling patientPortalMessageBoard.');
        }

        if (patientID === null || patientID === undefined) {
            throw new Error('Required parameter patientID was null or undefined when calling patientPortalMessageBoard.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (messageType !== undefined && messageType !== null) {
            queryParameters = queryParameters.set('messageType', <any>messageType);
        }
        if (patientID !== undefined && patientID !== null) {
            queryParameters = queryParameters.set('patientID', <any>patientID);
        }
        queryParameters = queryParameters.set('RoleId', '');
        queryParameters = queryParameters.set('practiceCode', '');
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<PatientPortalMessage>>(`${this.basePath}/PatientPortalMessageBoard`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


     public GetPatientPortalAttachementMessagesByPatientId(patientID: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {

        if (patientID === null || patientID === undefined) {
            throw new Error('Required parameter patientID was null or undefined when calling patientPortalMessageBoard.');
        }

        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });

        if (patientID !== undefined && patientID !== null) {
            queryParameters = queryParameters.set('patientID', <any>patientID);
        }
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<PatientPortalMessage>>(`${this.basePath}/GetPatientPortalAttachementMessagesByPatientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }


 public patientPortalAddOrDeleteAttachmentMessages(file: File, activity: string, isReport: string, patientId: any, observe?: 'body', reportProgress?: boolean): Observable<string>;
public patientPortalAddOrDeleteAttachmentMessages(file: File, activity: string, isReport: string, patientId: any, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
public patientPortalAddOrDeleteAttachmentMessages(file: File, activity: string, isReport: string, patientId: any, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
public patientPortalAddOrDeleteAttachmentMessages(file: File, activity: string, isReport: string, patientId: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    
    if (file === null || file === undefined) {
        throw new Error('Required parameter file was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    if (activity === null || activity === undefined) {
        throw new Error('Required parameter activity was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    if (isReport === null || isReport === undefined) {
        throw new Error('Required parameter isReport was null or undefined when calling patientPortalAddOrDeleteAttachmentMessages.');
    }

    // Create FormData for multipart/form-data
    const formData = new FormData();
    formData.append('UploadedFile', file, file.name); // This is the key part - must match API expectation
    formData.append('fileName', file.name);
    formData.append('activity', activity);
    formData.append('patientId', patientId);
    formData.append('isReport', isReport);

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});

    let headers = this.defaultHeaders;

    // authentication (api_key) required
    if (this.configuration.apiKeys["Context"]) {
        headers = headers.set('Context', this.configuration.apiKeys["Context"]);
    }

    // authentication (idp_auth) required
    if (this.configuration.accessToken) {
        const accessToken = typeof this.configuration.accessToken === 'function'
            ? this.configuration.accessToken()
            : this.configuration.accessToken;
        headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
        'application/json',
        'application/xml'
    ];
    const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
        headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // DO NOT set Content-Type header - let the browser set it with the boundary parameter
    // Remove any existing Content-Type header
    headers = headers.delete('Content-Type');

    return this.httpClient.post<string>(`${this.basePath}/AddOrDeleteAttachementMessages`,
        formData, // Send FormData instead of HttpParams
        {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers: headers,
            observe: observe,
            reportProgress: reportProgress
        }
    );
}

    public GetHistory(parentMessageId: number, messageId: number, observe: any = 'body', reportProgress: boolean = false): Observable<any> {


        let queryParameters = new HttpParams({ encoder: new CustomHttpUrlEncodingCodec() });
        queryParameters = queryParameters.set('ParentMessageId', <any>parentMessageId);
        queryParameters = queryParameters.set('MessageID', <any>messageId);
        let headers = this.defaultHeaders;

        // authentication (api_key) required
        if (this.configuration.apiKeys["Context"]) {
            headers = headers.set('Context', this.configuration.apiKeys["Context"]);
        }

        // authentication (idp_auth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml',
            'application/text'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];

        return this.httpClient.get<Array<any>>(`${this.baseComPath}/GetHistory`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
